import { render, staticRenderFns } from "./createOrganisation_page.vue?vue&type=template&id=322b1381&scoped=true&"
import script from "./createOrganisation_page.vue?vue&type=script&lang=js&"
export * from "./createOrganisation_page.vue?vue&type=script&lang=js&"
import style0 from "./createOrganisation_page.vue?vue&type=style&index=0&id=322b1381&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322b1381",
  null
  
)

export default component.exports